import React, { useState } from 'react';
import { renderProcessedText } from '../../utils/textRenderer';

interface OptionsDisplayProps {
  options: string[];
  onOptionSelect?: (option: string) => void;
  layout?: 'vertical' | 'horizontal'; // New layout configuration prop
}

const OptionsDisplay: React.FC<OptionsDisplayProps> = ({ 
  options, 
  onOptionSelect, 
  layout = 'horizontal' // Default to horizontal layout
}) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  console.log(options,"optionsDisplay");
  console.log("Layout prop received:", layout); // Debug logging
  console.log("Applied CSS class:", `options-display options-display--${layout}`); // Debug logging
  

  const handleOptionClick = (option: string) => {
    if (selectedOption) return; // Prevent multiple selections
    
    setSelectedOption(option);
    onOptionSelect?.(option);
  };

  return (
    <div className={`options-display options-display--${layout}`}>
      <div className="options-display__container">
        {options.map((option, index) => (
          <button
            key={index}
            className={`options-display__button ${
              selectedOption === option ? 'options-display__button--selected' : ''
            } ${selectedOption && selectedOption !== option ? 'options-display__button--disabled' : ''}`}
            onClick={() => handleOptionClick(option)}
            disabled={selectedOption !== null}
          >
            <span>{renderProcessedText(option)}</span>
            {selectedOption === option && (
              <span className="options-display__checkmark"> ✓</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default OptionsDisplay;
